/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pro_User_Appreciation_Letter_Commitment_Check2Inputs */

const en_pro_user_appreciation_letter_commitment_check2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All original Pro features`)
};

const ar_pro_user_appreciation_letter_commitment_check2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جميع ميزات نسخة المحترفين الأصلية`)
};

const de_pro_user_appreciation_letter_commitment_check2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle ursprünglichen Pro-Funktionen`)
};

const es_pro_user_appreciation_letter_commitment_check2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las funciones originales de Pro`)
};

const fr_pro_user_appreciation_letter_commitment_check2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toutes les fonctionnalités Pro`)
};

const it_pro_user_appreciation_letter_commitment_check2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutte le funzionalità originali Pro`)
};

const ja_pro_user_appreciation_letter_commitment_check2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのPro機能`)
};

const ko_pro_user_appreciation_letter_commitment_check2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 Original Pro 기능`)
};

const pt_br_pro_user_appreciation_letter_commitment_check2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as funcionalidades originais Pro`)
};

const ru_pro_user_appreciation_letter_commitment_check2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все оригинальные функции Pro`)
};

const th_pro_user_appreciation_letter_commitment_check2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณสมบัติโปรครบทั้งหมด`)
};

const tr_pro_user_appreciation_letter_commitment_check2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm orijinal Pro özellikleri`)
};

const zh_cn_pro_user_appreciation_letter_commitment_check2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原专业版功能`)
};

const zh_tw_pro_user_appreciation_letter_commitment_check2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原專業版功能`)
};

/**
* | output |
* | --- |
* | "All original Pro features" |
*
* @param {Pro_User_Appreciation_Letter_Commitment_Check2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const pro_user_appreciation_letter_commitment_check2 = /** @type {((inputs?: Pro_User_Appreciation_Letter_Commitment_Check2Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pro_User_Appreciation_Letter_Commitment_Check2Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pro_user_appreciation_letter_commitment_check2(inputs)
	if (locale === "ar") return ar_pro_user_appreciation_letter_commitment_check2(inputs)
	if (locale === "de") return de_pro_user_appreciation_letter_commitment_check2(inputs)
	if (locale === "es") return es_pro_user_appreciation_letter_commitment_check2(inputs)
	if (locale === "fr") return fr_pro_user_appreciation_letter_commitment_check2(inputs)
	if (locale === "it") return it_pro_user_appreciation_letter_commitment_check2(inputs)
	if (locale === "ja") return ja_pro_user_appreciation_letter_commitment_check2(inputs)
	if (locale === "ko") return ko_pro_user_appreciation_letter_commitment_check2(inputs)
	if (locale === "pt_br") return pt_br_pro_user_appreciation_letter_commitment_check2(inputs)
	if (locale === "ru") return ru_pro_user_appreciation_letter_commitment_check2(inputs)
	if (locale === "th") return th_pro_user_appreciation_letter_commitment_check2(inputs)
	if (locale === "tr") return tr_pro_user_appreciation_letter_commitment_check2(inputs)
	if (locale === "zh_cn") return zh_cn_pro_user_appreciation_letter_commitment_check2(inputs)
	return zh_tw_pro_user_appreciation_letter_commitment_check2(inputs)
});